import React, { useEffect, useState, useCallback } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { format, parseISO } from "date-fns";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import api from "../../../services/api";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useAguarde, useMessageBox } from "../../../contexts/globalContext";
import formatValue from "../../../utils/formatValue";
import DataTableDefault from "../../../components/DataTable/DataTableDefault";
import columnsFaixa from "./datatableColumns";

const FaixaRetornoListarPage = (props) => {
  const { setAguarde } = useAguarde();
  const { setMessageBox } = useMessageBox();

  const [faixaSelecionada, setFaixaSelecionada] = useState("");
  const [modalExcluir, setModalExcluir] = useState(false);
  const [faixas, setFaixas] = useState([]);

  const excluirFaixa = useCallback(async () => {
    try {
      setModalExcluir(false);
      setAguarde(true);
      const response = await api.delete(
        `/web/faixavalorcashback/${faixaSelecionada}`
      );
      setAguarde(false);

      if (!response.data.success) {
        throw response.data;
      }

      const auxFaixas = faixas.filter(
        (servico) => servico.faixaValorCashbackId !== faixaSelecionada
      );

      setFaixas(auxFaixas);

      await setMessageBox({
        show: true,
        title: "Sucesso",
        description: "Faixa excluída com sucesso.",
        success: true,
      });
    } catch (err) {
      setAguarde(false);
      await setMessageBox({
        show: true,
        title: "Erro",
        description: err.message,
        error: true,
      });
    }
  }, [setAguarde, setMessageBox, faixaSelecionada, faixas]);

  useEffect(() => {
    async function getFaixa() {
      try {
        setAguarde(true);
        const response = await api.get("/web/faixavalorcashback");
        setAguarde(false);

        if (!response.data.success) {
          throw response.data;
        }

        const listaFaixa = response.data.data.map((faixa) => {
          return {
            ...faixa,
            valorInicial: formatValue(faixa.valorInicial, "currency"),
            valorFinal: formatValue(faixa.valorFinal, "currency"),
            aliquotaCashback: formatValue(faixa.aliquotaCashback, "percent"),
            dataAlteracao: format(
              parseISO(faixa.dataAlteracao),
              "dd/MM/yyyy hh:mm"
            ),
            status:
              faixa.status === 1 ? (
                <div className="text-center">
                  <span className="badge badge-pill badge-soft-success font-size-11">
                    Ativo
                  </span>
                </div>
              ) : (
                <div className="text-center">
                  <span className="badge badge-pill badge-soft-danger font-size-11">
                    Inativo
                  </span>
                </div>
              ),
            action: (
              <>
                <Link
                  to={`/cadastros/faixaretorno/exibir?id=${faixa.faixaValorCashbackId}`}
                  className="mr-1 text-info"
                >
                  <i
                    className="mdi mdi-binoculars font-size-18 align-middle mr-1"
                    id="exibirTooltip"
                  ></i>
                </Link>

                <Link
                  to={`/cadastros/faixaretorno/alterar?id=${faixa.faixaValorCashbackId}`}
                  className="mr-1 text-warning"
                >
                  <i
                    className="bx bx-edit-alt font-size-18 align-middle mr-1"
                    id="alterarTooltip"
                  ></i>
                </Link>

                <Link
                  onClick={() => {
                    setFaixaSelecionada(faixa.faixaValorCashbackId);
                    setModalExcluir(true);
                  }}
                  to={() => {}}
                  className="mr-1 text-danger"
                >
                  <i
                    className="bx bx-trash font-size-18 align-middle mr-1"
                    id="excluirTooltip"
                  ></i>
                </Link>
              </>
            ),
          };
        });
        setFaixas(listaFaixa);
      } catch (err) {
        setFaixas([]);
        setAguarde(false);
        await setMessageBox({
          show: true,
          title: "Erro",
          description: err.message,
          error: true,
        });
      }
    }
    getFaixa();
  }, [setAguarde, setMessageBox]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Lista de Faixas" breadcrumbItem="Faixa" />

          {modalExcluir ? (
            <SweetAlert
              title="Deseja realmente excluir esta faixa?"
              warning
              showCancel
              confirmBtnBsStyle="success"
              confirmBtnText="Excluir"
              cancelBtnBsStyle="danger"
              cancelBtnText="Cancelar"
              onConfirm={excluirFaixa}
              onCancel={() => {
                setModalExcluir(false);
              }}
            ></SweetAlert>
          ) : null}

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="button-items">
                    <Link
                      className="btn btn-rounded btn-success waves-effect waves-light mr-1"
                      to="/cadastros/faixaretorno/incluir"
                    >
                      <i className="bx bx-plus font-size-16 align-middle mr-1"></i>
                      Incluir
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <DataTableDefault dataSource={columnsFaixa(faixas)} />
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FaixaRetornoListarPage;
